import '~/js/libs/jquery.waypoint';
import '~/js/libs/sticky';

// Variable Declaration
const resortMenu = document.getElementById('resort-menu');
const toggleButton = document.getElementById('resort-menu-btn');
const isFixedNav = resortMenu.classList.contains('fixed-menu');
const topPosition = resortMenu.classList.contains('top-position');
const middlePosition = resortMenu.classList.contains('middle-position');
const specialsMenu = document.getElementsByClassName('resort-menu--specials')[0];
let waypointSticky;

// Internals Variables
const settings = {
  optionsTop: {
    element: resortMenu,
    offset: 128,
    stuckClass: 'stuck-rm-top'
  },
  optionsMiddle: {
    element: resortMenu,
    offset: 40,
    stuckClass: 'stuck-rm-top'
  }
};

// Sticky Nav
const setSticky = () => {
  if (!isFixedNav) {
    let stickySettings;

    if (topPosition) {
      stickySettings = settings.optionsTop;
    } else if (middlePosition) {
      stickySettings = settings.optionsMiddle;
    }

    waypointSticky = new window.Waypoint.Sticky(stickySettings);
  }
};

setSticky();

// Toggle Sticky Nav
if(typeof specialsMenu !== 'undefined') {
  specialsMenu.addEventListener('click', () =>
    resortMenu.classList.toggle('open')
  );
} else {
  toggleButton.addEventListener('click', () =>
    resortMenu.classList.toggle('open')
  );
}

const stickyNav = _globalUtils.debounce(() => {
  waypointSticky.destroy();
  setSticky();
}, 100);

window.addEventListener('resize', stickyNav);